// /src/hooks/useImageModal.js
import { useState } from 'react';

function useImageModal() {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedImageSrc, setSelectedImageSrc] = useState(null);

    const openModal = (src) => {
        //console.log('Opening modal with src:', src);
        setSelectedImageSrc(src);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setSelectedImageSrc(null);
    };

    return {
        modalIsOpen,
        selectedImageSrc,
        openModal,
        closeModal
    };
}

export default useImageModal;
